import { render, staticRenderFns } from "./OauthCallback.vue?vue&type=template&id=8c0317fc&"
import script from "./OauthCallback.vue?vue&type=script&lang=js&"
export * from "./OauthCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports